import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextLink from 'LuxKit/TextLink'

interface Props {
  onResetFilter?: () => void
  showReviewFiltersAndUserDetails?: boolean
}

function UserReviewEmptyState(props: Props) {
  const { onResetFilter, showReviewFiltersAndUserDetails = true } = props
  const intl = useIntl()

  const noReviewsHeading = intl.formatMessage({
    id: 'vF8KA+GQMz',
    defaultMessage: 'Sorry, there are no reviews',
    description: 'Heading shown when there are no reviews available',
  })

  const noReviewsForSelectionHeading = intl.formatMessage({
    id: '3ypHtw4yCA',
    defaultMessage: 'Sorry, there are no reviews for your selection',
    description: 'Heading shown when no reviews match the selected filters',
  })

  return (
    <Group fullWidth direction="vertical" horizontalAlign="center" gap={4}>
      {!showReviewFiltersAndUserDetails && <Heading variant="heading6">{noReviewsHeading}</Heading>}
      {showReviewFiltersAndUserDetails && <>
        <Heading variant="heading6">{noReviewsForSelectionHeading}</Heading>
        <BodyText variant="medium">
          <FormattedMessage
            id="Wn8ybtDDfa"
            defaultMessage="Please try adjusting your filters below or <link>show all reviews</link>"
            description="Body text with link to reset filters and show all reviews"
            values={{
              link: (chunks) => <TextLink size="medium" weight="bold" onClick={onResetFilter}>{chunks}</TextLink>,
            }}
          />
        </BodyText>
      </>}
    </Group>
  )
}

export default UserReviewEmptyState
